import create from 'zustand';
import { apiDomStore } from 'Stores/Dom';

const { setBlockPageScroll, setBlockSideBarScroll, setCantExitModal } = apiDomStore.getState();

const onHideModal = () => {
	setBlockPageScroll(false);
	setBlockSideBarScroll(false);
	setCantExitModal(false);

	return {
		showModal: false
	};
};

const onShowModal = (modalName, params) => {
	setBlockPageScroll(true);
	setBlockSideBarScroll(true);

	return {
		showModal: true,
		activeModal: { name: modalName, params }
	};
};

const [useModalStore] = create(set => ({
	activeModal: null,
	setActiveModal: (modalName, params) => set(onShowModal(modalName, params)),
	showModal: false,
	hideModal: () => set(onHideModal())
}));

export default useModalStore;
